import { useQuery } from '@tanstack/react-query';
import { getLeadStatusCounts } from 'api/leads';
import httpClient from 'api/httpClient';
import { LeadStatusCount } from 'models/Lead';
import { CampaignType } from 'models/Campaign';
import { API_PATHS } from 'api';

const fetchLeadTabs = async (
  campaignId: string,
  campaignType: CampaignType,
) => {
  const path =
    campaignType === CampaignType.Personal
      ? API_PATHS.personalCampaigns.getPersonalCampaignLeadCounts(campaignId)
      : getLeadStatusCounts();
  const response = await httpClient.get<LeadStatusCount>(path, {
    params: { campaignId },
  });
  return response.data;
};

const useLeadTabs = (campaignId: string, campaignType: CampaignType) => {
  const key = campaignType === CampaignType.Personal ? 'personal-tabs' : 'tabs';
  return useQuery({
    queryKey: [key, { campaignId }],
    queryFn: () => fetchLeadTabs(campaignId, campaignType),
    enabled: !!campaignId,
  });
};

export default useLeadTabs;
